var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "month-with-prices__month-area" };
var _hoisted_2 = { class: "month-with-prices__month-area__inner" };
import { computed, inject, nextTick, ref, watch } from 'vue';
import CalendarMonth from '../CalendarControl/CalendarMonth.vue';
import useCalendarApiPriceProvider from '../../hooks/useCalendarApiPriceProvider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import createAmadeusBestPricesRequest from '../../lib/createAmadeusBestPricesRequest';
import optiClient from '../../services/api';
import CalendarDaysOfWeek from '../CalendarControl/CalendarDaysOfWeek.vue';
import { watchDebounced } from '@vueuse/core';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MonthWithPrices',
    props: {
        month: {},
        range: { type: Boolean },
        isLarge: { type: Boolean },
        itineraries: {},
        selectedRange: {}
    },
    emits: ["day:clicked"],
    setup: function (__props) {
        var _this = this;
        var _a;
        var props = __props;
        dayjs.extend(utc);
        var apiPrices = ref();
        var departValueRef = computed(function () { return props.selectedRange[0] ? dayjs(props.selectedRange[0]).toDate().toLocaleDateString('en-CA') : dayjs(props.month).startOf('month').toDate().toLocaleDateString('en-CA'); });
        var itinerariesRef = computed(function () { return props.itineraries; });
        var returnValueRef = ref();
        var oneWayRef = computed(function () { return props.itineraries.length === 1; });
        var fareFamilies = (_a = inject('amadeus-fare-families')) !== null && _a !== void 0 ? _a : ['CFFECOBIZ', 'CFFBIZ'];
        var el = ref(null);
        var scrollAnchor = ref(null);
        var pricesRequest = computed(function () {
            if (!itinerariesRef.value[0].fromAirport || !itinerariesRef.value[0].toAirport)
                return null;
            var dayjsMonth = dayjs(props.month).startOf('month');
            return createAmadeusBestPricesRequest({
                originLocationCode: itinerariesRef.value[0].fromAirport.locIATA,
                destinationLocationCode: itinerariesRef.value[0].toAirport.locIATA,
                departureDateTime: props.selectedRange[0] ? props.selectedRange[0] : dayjsMonth.isBefore(dayjs()) ? dayjs().add(1, 'day').toDate() : dayjsMonth.startOf('month').toDate(),
                tripDuration: itinerariesRef.value.length === 2 ? 7 : undefined,
                rangeOfDeparture: props.selectedRange[0] ? undefined : dayjsMonth.endOf('month').diff(dayjsMonth.startOf('month'), 'day') + 1,
                durationFlexibility: props.selectedRange[0] ? undefined : 1,
                fareFamilies: fareFamilies,
            });
        });
        var getFlightPrices = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, flights, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, optiClient.bookings.postApiV1BookingsFlightsSearch(pricesRequest.value)];
                    case 1:
                        res = _b.sent();
                        flights = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.flights;
                        flights = flights ? flights.filter(function (flight) { return dayjs(props.month).isSame(flight.departureDate, 'month'); }) : null;
                        apiPrices.value = __assign(__assign({}, res), { data: __assign(__assign({}, res.data), { 
                                // @ts-ignore our API is trasnforming this response a bit
                                flights: flights }) });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        watchDebounced(function () { return pricesRequest.value; }, function (newValue) {
            if (newValue) {
                getFlightPrices();
            }
        }, { maxWait: 500, debounce: 300, immediate: true });
        watch(apiPrices, function (newValue, oldValue) {
            if (newValue && !oldValue) {
                nextTick(function () {
                    var _a;
                    (_a = scrollAnchor.value) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
                });
            }
        });
        useCalendarApiPriceProvider(apiPrices, departValueRef, returnValueRef, oneWayRef);
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    ref_key: "scrollAnchor",
                    ref: scrollAnchor,
                    style: _normalizeStyle({ transform: "translateY(-".concat(_ctx.isLarge ? 435 : 180, "px)") })
                }, null, 4 /* STYLE */),
                _createElementVNode("div", {
                    ref_key: "el",
                    ref: el,
                    class: _normalizeClass([
                        'month-with-prices',
                        {
                            'month-with-prices--large': _ctx.isLarge,
                        }
                    ])
                }, [
                    _createVNode(CalendarDaysOfWeek),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(CalendarMonth, {
                                month: _ctx.month,
                                allowDaysOutOfDisplayedMonth: "",
                                "selected-range": _ctx.selectedRange,
                                range: _ctx.range,
                                "min-date": _unref(dayjs)().startOf('day').toDate(),
                                "onDay:clicked": _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('day:clicked', $event)); })
                            }, null, 8 /* PROPS */, ["month", "selected-range", "range", "min-date"])
                        ])
                    ])
                ], 2 /* CLASS */)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
